// styles
import { chartDashboardBoxStyle, chartDashboardType02SamsungStyle } from 'styles';

// libraries
import { LazyImage } from 'components';
import styled from 'styled-components';

export const StyledWeatherConditionCard = styled.div`
  > div {
    > div {
      ${chartDashboardBoxStyle}
      ${chartDashboardType02SamsungStyle}
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 111px;
    }
  }
`;

export const StyledImageWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  gap: 38px;
`;

export const StyledBox = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const StyledImage = styled(LazyImage)`
  width: 40px;
  height: 40px;
  object-fit: contain;
`;

export const StyledDescription = styled.div`
  display: flex;
  flex-direction: column;

  > h3 {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > p {
    color: var(--color-medium-gray);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
